import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { 
  Home, 
  User, 
  LayoutGrid, 
  FileText, 
  Github, 
  Star,
  Menu,
  X
} from "lucide-react";
import Avatar from "../Assets/avatar.svg";

function NavBar() {
  const [expand, setExpand] = useState(false);
  const [navColour, setNavColour] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY >= 20) {
        setNavColour(true);
      } else {
        setNavColour(false);
      }
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const navLinks = [
    { to: "/", icon: <Home size={20} />, label: "Home" },
    { to: "/about", icon: <User size={20} />, label: "About" },
    { to: "/project", icon: <LayoutGrid size={20} />, label: "Projects" },
    { to: "/resume", icon: <FileText size={20} />, label: "Resume" },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${navColour ? "py-2 glass neon-glow shadow-xl" : "py-4 bg-transparent"}`}>
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <img src={Avatar} className="w-10 h-10 group-hover:scale-110 transition-transform" alt="brand" />
          <span className="text-xl font-bold font-manrope text-white hidden sm:block">
            VIJAY<span className="text-primary">.B</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          <ul className="flex items-center gap-6">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="flex items-center gap-2 text-neutral-300 hover:text-primary transition-colors font-medium relative group"
                >
                  {link.icon}
                  {link.label}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all group-hover:w-full"></span>
                </Link>
              </li>
            ))}
          </ul>

          <a
            href="https://github.com/vijay5599/my-portfolio.git"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 px-5 py-2 bg-primary/10 border border-primary/20 rounded-xl text-primary hover:bg-primary hover:text-white transition-all font-bold"
          >
            <Github size={18} />
            <Star size={18} fill="currentColor" />
          </a>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-white p-2"
          onClick={() => setExpand(!expand)}
        >
          {expand ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {expand && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden glass border-t border-white/5 overflow-hidden"
          >
            <ul className="flex flex-col p-6 gap-4">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={() => setExpand(false)}
                    className="flex items-center gap-4 text-lg text-neutral-300 hover:text-primary"
                  >
                    {link.icon}
                    {link.label}
                  </Link>
                </li>
              ))}
              <li className="pt-4 border-t border-white/5">
                <a
                  href="https://github.com/vijay5599/my-portfolio.git"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-center gap-4 py-3 bg-primary rounded-xl text-white font-bold"
                >
                  <Github size={20} />
                  Star on GitHub
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}

export default NavBar;
